import { v4 as uuidv4 } from 'uuid';

class Utility {

    static htmlDecode(value) {
        var doc = new DOMParser().parseFromString(value, "text/html");
        if (doc) {
            return doc.documentElement.textContent;
        }
        return "";
    }

    static getUrlParameter(name) {
        let url = new URL(window.location.href);
        return url.searchParams.get(name);
    }

    static setUrlParameter(name, value) {
        let url = new URL(window.location.href);
        if(!url.searchParams.get(name)) {
            url.searchParams.append(name, value);
        }
        url.searchParams.set(name, value);
        
        // push to browser url
        if (history.pushState) {
            // window.history.pushState({ path: url.href }, '', url.href);
            window.history.replaceState({}, document.title, url.href);
        }
    }

    static removeUrlParameter(name) {
        let url = new URL(window.location.href);
        if(url.searchParams.get(name)) {
            url.searchParams.delete(name);
        }
        if (history.pushState) {
            // window.history.pushState({ path: url.href }, '', url.href);
            window.history.replaceState({}, document.title, url.href);
        }
    }

    static detectBrowserOS() {
        let browserAppVer : string = window.navigator.appVersion;
        let osName : string = "Unknown";
        if (browserAppVer.indexOf("Win") > -1) osName = "Windows";
        if (browserAppVer.indexOf("Mac") > -1) osName = "MacOS";
        if (browserAppVer.indexOf("X11") > -1) osName = "UNIX";
        if (browserAppVer.indexOf("Linux") > -1) osName = "Linux";
        if (browserAppVer.indexOf("Android") > -1) osName = "Android";
        return osName;
    }

    static validateUrl(url:string) {
        let isValid : boolean = false;
        if (url.length <= 500) {
            if (url.indexOf('www') > -1 || url.indexOf('http') > -1 || url.indexOf('https') || url.indexOf('.ca') || url.indexOf('.com')) {
                isValid = true;
            }
        }
        return isValid;
    }
    
    static removeInjectedTags(strContent : string){
        if(strContent === '' || strContent === null){
            return '';
        }
        return strContent.replace( /(<([^>]+)>)/ig, '');
    }

    static detectBrowserVersion() {
        let browserVersion = (function () {
            var useragent = navigator.userAgent, tem,
                M = useragent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if (/trident/i.test(M[1])) {
                tem = /\brv[ :]+(\d+)/g.exec(useragent) || [];
                return 'IE ' + (tem[1] || '');
            }
            if (M[1] === 'Chrome') {
                tem = useragent.match(/\b(OPR|Edge)\/(\d+)/);
                if (tem !== null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
            }
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = useragent.match(/version\/(\d+)/i)) !== null) M.splice(1, 1, tem[1]);
            return M.join(' ').toString();
        })();
        if (browserVersion)
            return browserVersion;
        else
            return "unknown";
    }

    static async sha256(message) {
        // encode as UTF-8
        const msgBuffer = new TextEncoder().encode(message);
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
        // convert ArrayBuffer to Array
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        // convert bytes to hex string
        const hashHex = hashArray.map(b => ('00' + b.toString(16)).slice(-2)).join('');
        return hashHex;
    }

    static asyncLocalStorage = {
        setItem: function (key, value) {
            return Promise.resolve().then(function () {
                localStorage.setItem(key, value);
            });
        },
        getItem: function (key) {
            return Promise.resolve().then(function () {
                return localStorage.getItem(key);
            });
        }
    }

    static randomLetters(length) {
        let result           = '';
        let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        let charactersLength = characters.length;
        for ( let i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    static isTouchDevice() {
        return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0));
    }

    static removeAfterHyphen(value: string) {
        if (value.includes(" -"))
        {
            return value.split(" -")[0];
        }
        return value;
    }

    static uuidv4() {
        return uuidv4();
    }

    static toCamelCase(str) {
        return str
            .toLowerCase()
            .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
                return index === 0 ? match.toLowerCase() : match.toUpperCase();
            })
            .replace(/\s+/g, ''); // Remove all spaces
    }

    //function to manage YouTube API loading
    static isYouTubeApiLoaded = false;
    
    static loadYouTubeAPI() {
        if (!this.isYouTubeApiLoaded) {
            const scriptTag = document.createElement('script');
            scriptTag.src = 'https://www.youtube.com/iframe_api';
            document.head.appendChild(scriptTag);
            this.isYouTubeApiLoaded = true;

            // Global YouTube API ready handler
            (window as any).onYouTubeIframeAPIReady = () => {
                document.dispatchEvent(new Event('youtubeApiReady'));
            };
        }
    }
}
export default Utility;